import { API, authClient } from "../index";

export const getEventParticipationByEvent = (eventId) => {
	return authClient().get(`${API}/event-participant/by-event/${eventId}`);
};
